import React from 'react';

const CheckCircleBroken = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none">
      <g clip-path="url(#a)">
        <path
          stroke="#06AED4"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M14.667 7.39v.614a6.666 6.666 0 1 1-3.953-6.094m3.953.757L8.001 9.34l-2-2"
        />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M0 0h16v16H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default CheckCircleBroken;
